import { Question } from "../../types/Question";
import { request } from "../apiService";

export const getUserQuestions = async () => {
    return await request<Question[]>("/v2/users/questions");
};

export const updateUserQuestions = async (
    answers: { questionId: string; answer: string }[]
) => {
    return await request<void, { questionId: string; answer: string }[]>(
        "/v2/users/questions",
        {
            method: "PUT",
            input: answers,
        }
    );
};
